export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home',
  about: 'nav-about',
  groupCompanies: 'nav-group-companies',
  industries: 'nav-industries',
  projects: 'nav-projects',
  globalPresence: 'nav-global-presence',
  careers: 'nav-careers',
  contact: 'nav-contact',
  mobileToggle: 'nav-mobile-toggle',
  mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
  headline: 'hero-headline',
};

export const HOMEPAGE = {
  metricsSection: 'home-metrics',
  whoWeAre: 'home-who-we-are',
  groupCompanies: 'home-group-companies',
  industries: 'home-industries',
  projects: 'home-projects',
  globalMap: 'home-global-map',
  cta: 'home-cta',
};

export const GROUP = {
  card: (slug) => `group-card-${slug}`,
  cardCta: (slug) => `group-card-cta-${slug}`,
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  company: 'contact-company',
  phone: 'contact-phone',
  subject: 'contact-subject',
  message: 'contact-message',
  interest: 'contact-interest',
  submit: 'contact-submit',
  success: 'contact-success',
  error: 'contact-error',
};

export const CAREER = {
  form: 'career-form',
  name: 'career-name',
  email: 'career-email',
  phone: 'career-phone',
  role: 'career-role',
  experience: 'career-experience',
  currentCompany: 'career-current-company',
  location: 'career-location',
  coverLetter: 'career-cover-letter',
  portfolio: 'career-portfolio',
  submit: 'career-submit',
  success: 'career-success',
  error: 'career-error',
};

export const MAP = {
  container: 'world-map',
  country: (code) => `map-country-${code}`,
  tooltip: 'map-tooltip',
};

export const FOOTER = {
  root: 'site-footer',
  email: 'footer-email',
};
